import styled, { createGlobalStyle } from "styled-components";
import { ThemeType } from "task-eva-ui";

export const ModalStyle = createGlobalStyle`
  .ant-modal .ant-modal-content {
    background: ${(p) => (p.theme as ThemeType)["theme-1" as any]};
  }
  .ant-modal-close-icon {
    svg {
      fill: ${(p) => (p.theme as ThemeType)["color-fill-8" as any]};
    }
  }
`;
export const RuleWrapper = styled.div``;

export const RechargeRule = styled.div`
  color: ${(p) => p.theme["color-text-4"]};
  font-size: 12px;
  cursor: pointer;
`;

export const Title = styled.div`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 35px;
`;
export const Content = styled.div`
  margin: 14px auto 30px;
  display: flex;
  width: 432px;
  color: #8c9ca6;
  font-size: 14px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;
export const Footer = styled.div`
  margin: 0 auto;
`;

export const Button = styled.div`
  cursor: pointer;
  width: 144px;
  height: 39px;
  border-radius: 10px;
  background: linear-gradient(
      90deg,
      #3089ff -11.25%,
      #6d9fff 63.72%,
      #b49bff 119.77%
    ),
    #d9d9d9;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin: 0 auto;
  text-align: center;
  line-height: 39px;
  margin-bottom: 46px;
  &:hover {
    background: linear-gradient(
      90deg,
      #3daaff -11.25%,
      #62adff 63.72%,
      #c2adff 119.77%
    );
  }
  &:active {
    background: linear-gradient(
        90deg,
        #3089ff -11.25%,
        #6d9fff 63.72%,
        #b49bff 119.77%
      ),
      #d9d9d9;
  }
`;
